import React, {Component} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Navbar from "./Navbar";
import Title from "./Title";

class Header extends Component {
    render() {
        return (
            <div>
                <div className="custom-navbar" style={{
                    backgroundColor: '#e7e7e7',
                    height: '125px'
                }}>
                    <div  style={{
                        width: '80%',
                        margin: '0 auto'
                    }}>
                        <Navbar/>
                    </div>
                    
                </div>
                <div style={{backgroundColor: '#001e62'}}>
                    <div  style={{
                        width: '80%',
                        margin: '0 auto'
                    }}>
                        <Title/>
                    </div>
                    
                </div>
                
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/Header.js